// extracted by mini-css-extract-plugin
export default {"root":"HElURW1tlZM96vTMnOo4"};